module.exports = __webpack_public_path__ + "static/media/example-1.3f2180db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Millard/example-1.jpg
// module id = 269
// module chunks = 0